module.exports = __webpack_public_path__ + "img/bunny-ears-1.fc205839.svg";